import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/auth/Protected-route";
import Dashboard from "../pages/dashboard/dashboard";
import Courses from "../pages/quiz/courses/courses";
import InitialMessage from "../pages/quiz/initialMessage";
import Select from "../pages/quiz/select";

const PrivateRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ProtectedRoute />}>
                <Route path="/seleccionar" element={<Select />} />
                <Route path="/mensaje-inicial" element={<InitialMessage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/cursos/:name_course" element={<Courses />} />
            </Route>
        </Routes>
    )
}

export default PrivateRoutes;